var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help-menu"},[(_vm.currentInterstitialContent)?_c('button',{staticClass:"help-menu__btn",on:{"click":_vm.onHelpRequested}},[_c('responsive-img',{staticClass:"help-menu__img",attrs:{"width":116,"alt":"","src":"/images/menu_icons/help@3x.png"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }